import Vue from "vue";
import { INotificationOnClickResult, Notification } from "./notification";

export class NewPeppolOrderNotification extends Notification {
	public async onClick(vue:Vue):Promise<INotificationOnClickResult>{
		return {
			routeTo: "/inbox"
		};
	}

	public getIcon():string {
		return "inbox";
	}

	public getActionKey():string {
		return "open-inbox";
	}
}
